// extracted by mini-css-extract-plugin
export default {"iconColor":"#44cc94","assuranceWidget":"assuranceWidget__2Vx3i","assuranceWidgetContainer":"assuranceWidgetContainer__3sCQ3","headerTitle":"headerTitle__1dD-2","iconContainer":"iconContainer__2PkXl","headerContainer":"headerContainer__3rY2k","subHeaderContainer":"subHeaderContainer__2FrPZ","primaryButton":"primaryButton__3GVn9","content":"content__Gs2UF","footerButton":"footerButton__1w4ey","assuranceInfos":"assuranceInfos__2DK5v","markup":"markup__1xN8f"};
    if(module.hot) {
      // 1764953338899
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  